// fallback values
export const loadLockTypes = [
  {
    is_type: 'facility_commodity_excluded',
    metadata_id: 1,
    metadata_title: 'Cargo Exclusion',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_dispatch_service_domain',
    metadata_id: 8,
    metadata_title: 'Dispatch Service Domain',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_dispatch_service_email',
    metadata_id: 9,
    metadata_title: 'Dispatch Service Email',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_domain_spoofing',
    metadata_id: 10,
    metadata_title: 'Domain Spoofing',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_email_spoofing',
    metadata_id: 11,
    metadata_title: 'Email Spoofing',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'load_overall_rule_result_failing',
    metadata_id: 5,
    metadata_title: 'Failing Broker Requirements',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_fraudulent_domain',
    metadata_id: 12,
    metadata_title: 'Fraudulent Domain',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'rate_confirmation_fraudulent_email',
    metadata_id: 13,
    metadata_title: 'Fraudulent Email',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'found_phone_flagged_for_fraud',
    metadata_id: 2,
    metadata_title: 'Fraudulent Phone Number',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'high_risk_area_with_no_physical_presence',
    metadata_id: 3,
    metadata_title: 'High Risk Area',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'physical_location_out_of_range_from_origin',
    metadata_id: 7,
    metadata_title: 'Out of Range',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'overbooked_carrier',
    metadata_id: 6,
    metadata_title: 'Overbooked Carrier',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'identity_alert_on_active_load',
    metadata_id: 4,
    metadata_title: 'Recent Identity Alert',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'unverified_vehicle_assigned',
    metadata_id: 14,
    metadata_title: 'Unverified Vehicle Assigned',
    subscription_level: 'load_lock',
  },
  {
    is_type: 'voip_phone_number',
    metadata_id: 15,
    metadata_title: 'VoIP Phone Number',
    subscription_level: 'load_lock',
  },
];

export const loadLockPlusTypes = [
  {
    is_type: 'carrier_assigned_eld_exempt_vehicle',
    metadata_id: 16,
    metadata_title: 'Carrier Assigned ELD Exempt Vehicle',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'dormant_vehicle_assigned',
    metadata_id: 17,
    metadata_title: 'Dormant Vehicle Assigned',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'failed_to_arrive_at_pickup',
    metadata_id: 19,
    metadata_title: 'Failed to Arrive at Pickup',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'received_tms_vehicle_and_not_found',
    metadata_id: 22,
    metadata_title: 'Provided Vehicle Not Found',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'eld_revoked_during_transit',
    metadata_id: 18,
    metadata_title: 'Revoked ELD',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'potentially_wrong_vehicle_assigned',
    metadata_id: 21,
    metadata_title: 'Route Deviation',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'high_value_load_stopped',
    metadata_id: 20,
    metadata_title: 'Unauthorized Stop',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'vehicle_assignment_required',
    metadata_id: 23,
    metadata_title: 'Vehicle Assignment Required',
    subscription_level: 'load_lock_plus',
  },
  {
    is_type: 'vehicle_not_nearby',
    metadata_id: 24,
    metadata_title: 'Vehicle Not Nearby',
    subscription_level: 'load_lock_plus',
  },
];

export const alertStatuses = {
  'alert-status-new': {
    id: 1,
    filterType: 'status',
    title: 'New',
    longTitle: 'Status: New',
    query: '&q[status_in][]=new',
  },
  'alert-status-progress': {
    id: 2,
    filterType: 'status',
    title: 'In Progress',
    longTitle: 'Status: In Progress',
    query: '&q[status_in][]=in_progress',
  },
  'alert-status-escalated': {
    id: 3,
    filterType: 'status',
    title: 'Escalated',
    longTitle: 'Status: Escalated',
    query: '&q[status_in][]=escalated',
  },
  'alert-status-pending': {
    id: 4,
    filterType: 'status',
    title: 'Pending',
    longTitle: 'Status: Pending',
    query: '&q[status_in][]=pending',
  },
};

export const alertAssignment = {
  unassigned: {
    filterType: 'alertAssignment',
    title: 'Unassigned',
    query: '&q[unassigned]=1',
  },
  assigned: {
    filterType: 'alertAssignment',
    title: 'Assigned',
    query: '&q[assigned]=1',
  },
};

// 'status-closed': {
//   id: 4,
//   filterType: 'status',
//   title: 'Closed',
//   query: '&q[status_in][]=closed',
// },

export const alertDropdownSearchFields = [
  { id: 'carrier', label: 'Carrier Name' },
  { id: 'dot', label: 'Carrier DOT' },
  { id: 'loadId', label: 'Load ID' },
  // { id: 'origin', label: 'Origin City' },
  // { id: 'destination', label: 'Destination City' },
];

export const alertSearchFields = {
  carrier: {
    id: 1,
    title: 'Carrier Name',
    query: '&q[carrier_legal_name_search_cont]',
  },
  mc: {
    id: 2,
    title: 'Carrier MC',
    query:
      '&q[carrier_identifiers_is_type_eq]=MC&q[carrier_identifiers_value_non_padded_eq]',
  },
  dot: {
    id: 3,
    title: 'Carrier DOT',
    query:
      '&q[carrier_identifiers_is_type_eq]=DOT&q[carrier_identifiers_value_non_padded_eq]',
  },
  loadId: {
    id: 4,
    title: 'Shipment ID',
    // query: '&q[external_id_in][]',
    query: '&q[single_external_load_number_equals]',
  },
  loadIdStart: {
    id: 4,
    title: 'Shipment ID',
    query: '&q[single_external_load_number_start]',
  },
  shipperId: {
    id: 4,
    title: 'Shipper ID',
    query: '&q[order_shipper_external_id_cont]',
  },
  alertLoadId: {
    id: 4,
    title: 'Alert Shipment ID',
    query: '&q[single_external_load_number_equals]',
  },
  pickup: {
    id: 5,
    title: 'Scheduled Pickup date',
    query: '&q[start_stop_scheduled_window_started_at_date_eq]',
  },
  pickupStart: {
    id: 5,
    title: 'Scheduled Pickup start range date',
    query: '&q[start_stop_scheduled_window_started_at_date_gteq]',
  },
  pickupEnd: {
    id: 5,
    title: 'Scheduled Pickup end range date',
    query: '&q[start_stop_scheduled_window_started_at_date_lteq]',
  },
  alert_pickupStart: {
    id: 5,
    title: 'Scheduled Pickup start range date',
    query: '&q[load_start_stop_scheduled_window_started_at_date_gteq]',
  },
  alert_pickupEnd: {
    id: 5,
    title: 'Scheduled Pickup end range date',
    query: '&q[load_start_stop_scheduled_window_started_at_date_lteq]',
  },
  delivery: {
    id: 6,
    title: 'Scheduled Delivery date',
    query: '&q[end_stop_scheduled_window_started_at_date_eq]',
  },
  deliveryStart: {
    id: 6,
    title: 'Scheduled Delivery start range date',
    query: '&q[end_stop_scheduled_window_started_at_date_gteq]',
  },
  deliveryEnd: {
    id: 6,
    title: 'Scheduled Delivery end range date',
    query: '&q[end_stop_scheduled_window_started_at_date_lteq]',
  },
  alert_deliveryStart: {
    id: 6,
    title: 'Scheduled Delivery start range date',
    query: '&q[load_end_stop_scheduled_window_started_at_date_gteq]',
  },
  alert_deliveryEnd: {
    id: 6,
    title: 'Scheduled Delivery end range date',
    query: '&q[load_end_stop_scheduled_window_started_at_date_lteq]',
  },
  origin: {
    id: 7,
    title: 'Origin postal code',
    query: '&q[start_stop_postal_code_eq]',
  },
  origin_zip: {
    id: 7,
    title: 'Origin postal code',
    query: '&q[start_stop_postal_code_eq]',
  },
  origin_state: {
    id: 7,
    title: 'Origin state code',
    query: '&q[start_stop_state_eq]',
  },
  destination: {
    id: 8,
    title: 'Destination postal code',
    query: '&q[end_stop_postal_code_eq]',
  },
  destination_zip: {
    id: 8,
    title: 'Destination postal code',
    query: '&q[end_stop_postal_code_eq]',
  },
  destination_state: {
    id: 8,
    title: 'Destination state code',
    query: '&q[end_stop_state_eq]',
  },
  alert_pickup: {
    id: 5,
    title: 'Scheduled Pickup date',
    query: '&q[by_start_stop_scheduled_date]',
  },
  alert_delivery: {
    id: 6,
    title: 'Scheduled Delivery date',
    query: '&q[by_end_stop_scheduled_date]',
  },
  alert_origin: {
    id: 7,
    title: 'Origin postal code',
    query: '&q[by_start_stop_stop_postal_code]',
  },
  alert_destination: {
    id: 8,
    title: 'Destination postal code',
    query: '&q[by_end_stop_stop_postal_code]',
  },
  team: {
    id: 10,
    title: 'Team ID',
    query: '&q[team_id_eq]',
  },
  alert_team: {
    id: 11,
    title: 'Load Team ID',
    query: '&q[load_team_id_eq]',
  },
  broker: {
    id: 12,
    title: 'Broker ID',
    query: '&q[company_id_in][]',
  },
};

export const alertSortFields = {
  priority_asc: {
    id: 1,
    title: 'Ascending by Priority',
    query: 'priority+asc',
  },
  priority_desc: {
    id: 2,
    title: 'Descending by Priority',
    query: 'priority+desc',
  },
  origin_asc: {
    id: 1,
    title: 'Ascending by Origin',
    query: 'start_stop_scheduled_window_started_at+asc',
  },
  origin_desc: {
    id: 2,
    title: 'Descending by Origin',
    query: 'start_stop_scheduled_window_started_at+desc',
  },
  destination_asc: {
    id: 3,
    title: 'Ascending by Destination',
    query: 'end_stop_scheduled_window_started_at+asc',
  },
  destination_desc: {
    id: 4,
    title: 'Descending by Destination',
    query: 'end_stop_scheduled_window_started_at+desc',
  },
  alert_origin_asc: {
    id: 1,
    title: 'Ascending by Origin',
    query: 'load_start_stop_scheduled_window_started_at+asc',
  },
  alert_origin_desc: {
    id: 2,
    title: 'Descending by Origin',
    query: 'load_start_stop_scheduled_window_started_at+desc',
  },
  alert_destination_asc: {
    id: 3,
    title: 'Ascending by Destination',
    query: 'load_end_stop_scheduled_window_started_at+asc',
  },
  alert_destination_desc: {
    id: 4,
    title: 'Descending by Destination',
    query: 'load_end_stop_scheduled_window_started_at+desc',
  },
  assignee_id_asc: {
    id: 3,
    title: 'Ascending by Owner ID',
    query: 'assignee_id+asc',
  },
  assignee_id_desc: {
    id: 4,
    title: 'Descending by Owner ID',
    query: 'assignee_id+desc',
  },
  created_at_asc: {
    id: 3,
    title: 'Ascending by Owner ID',
    query: 'created_at+asc',
  },
  created_at_desc: {
    id: 4,
    title: 'Descending by Owner ID',
    query: 'created_at+desc',
  },
};

export const defaultAlertFilters = {
  open: '_alert-status-new_alert-status-progress_alert-status-escalated',
  closed: '',
  pending: '',
  recommended: '',
};

export const defaultAlertSort = {
  open: '',
  closed: '',
  pending: '',
  recommended: '',
};

export const alertFilters = { ...alertStatuses, ...alertAssignment };
